<div class="page-container">
  <div class="max-content-width spaced-sections">
    <div>
      <h1 class="page-title">Groups</h1>
      <p class="page-subtitle">All groups you are currently part of.</p>
    </div>

    <div class="relative">
      <svg
        class="absolute w-4 h-4 text-gray-400 pointer-events-none"
        style="left: 1rem; top: 50%; transform: translateY(-50%)"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
      <input
        type="text"
        placeholder="Search groups by name or description..."
        [value]="searchQuery()"
        (input)="onSearchInput($any($event.target).value)"
        class="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 pl-11 pr-10 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-shadow"
      />
      @if (searchQuery()) {
        <button
          type="button"
          (click)="clearSearch()"
          class="absolute p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          style="right: 0.75rem; top: 50%; transform: translateY(-50%)"
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4 h-4">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      }
    </div>

    @if (loading()) {
      <div class="card card-padding text-center py-10 text-gray-600">Loading groups...</div>
    } @else if (errorMessage()) {
      <div class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage() }}
      </div>
    } @else if (searchActive() && groups().length === 0) {
      <section class="card">
        <div class="empty-state">
          <div class="empty-state-icon">🔍</div>
          <h3 class="empty-state-title">No groups found</h3>
          <p class="empty-state-message">
            @if (searchQuery().length > 0) {
              No groups match "{{ searchQuery() }}". Try a different search term.
            } @else {
              No groups match your search.
            }
          </p>
        </div>
      </section>
    } @else if (totalItems() === 0) {
      <section class="card">
        <div class="empty-state">
          <div class="empty-state-icon">📚</div>
          <h3 class="empty-state-title">No groups yet</h3>
          <p class="empty-state-message">
            You are not part of any groups yet. Create or join a group to get started.
          </p>
        </div>
      </section>
    } @else {
      <div class="card divide-y divide-slate-200">
        @for (group of groups(); track group.id) {
          <div
            class="flex items-center gap-3 px-6 py-4 cursor-pointer transition-colors hover:bg-slate-50/80"
            (click)="openGroup(group)"
            (keydown.enter)="openGroup(group)"
            role="button"
            tabindex="0"
          >
            <div class="avatar-small">
              {{ group.name.charAt(0).toUpperCase() }}
            </div>
            <div class="min-w-0 flex-1">
              <div class="mb-1">
                <div class="flex items-center gap-2">
                  <span class="text-base font-semibold text-gray-900">{{ group.name }}</span>
                  <span class="badge-primary">
                    {{ isOwner(group) ? 'Owner' : 'Member' }}
                  </span>
                </div>
                @if (group.description) {
                  <p class="mt-0.5 text-sm text-gray-600 line-clamp-2">
                    {{ group.description }}
                  </p>
                }
              </div>
              <div class="flex items-center gap-1 text-xs text-gray-500">
                <span>{{ group.memberCount }} member{{ group.memberCount !== 1 ? 's' : '' }}</span>
                <span class="text-gray-300">·</span>
                <span
                  >{{ group.projectCount }} project{{ group.projectCount !== 1 ? 's' : '' }}</span
                >
                @if (group.createdAt) {
                  <span class="text-gray-300">·</span>
                  <span>Created {{ group.createdAt | date: 'MMM d, yyyy' }}</span>
                }
              </div>
            </div>
            <svg
              class="w-4 h-4 flex-shrink-0 text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        }
      </div>

      @if (totalPages() > 1) {
        <div class="flex items-center justify-between px-2 py-3 text-sm text-gray-600">
          <button
            type="button"
            (click)="goToPage(currentPage() - 1)"
            [disabled]="!canPrev()"
            class="btn-small-secondary disabled:cursor-not-allowed disabled:opacity-40"
          >
            « Prev
          </button>
          <span>Page {{ currentPage() + 1 }} of {{ totalPages() }}</span>
          <button
            type="button"
            (click)="goToPage(currentPage() + 1)"
            [disabled]="!canNext()"
            class="btn-small-secondary disabled:cursor-not-allowed disabled:opacity-40"
          >
            Next »
          </button>
        </div>
      }
    }
  </div>
</div>
